// extracted by mini-css-extract-plugin
export default {"imageContainer":"I1-z","summaryPar":"J1-z","ratingCategories":"K1-z","reviewerInfo":"L1-z","reviewTypes":"M1-z","expanded":"N1-z"};